import Vue from 'vue'
import App from './App.vue'
import VueAffix from 'vue-affix'

import store from './store/index.js'

Vue.use(VueAffix)

const app = new Vue({
    render: h => h(App),
    store,
}).$mount('#app');

Vue.config.devtools = true


// WEBPACK FOOTER //
// ./src/main.js